import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingAccessControlContent } from '../utils/vpsHostingContent';

export const useVpsHostingAccessControlContent = () =>
  useVpsHostingSectionContent(parseVpsHostingAccessControlContent);
